export default "__VITE_ASSET__CKxyhwoM__"